import React from "react";
import SearchIcon from "../../../images/printers/search.svg";
import {
    Container,
    InputContainer,
    InputContent,
    InputIcon,
    SearchInput,
} from "./DeviceFilters.styles";

interface DeviceFiltersProps {
    value: string;
    placeholder: string;
    onChange: (value: string) => void;
}

const DeviceFilters: React.FC<DeviceFiltersProps> = ({ value, placeholder, onChange }) => {
    return (
        <Container>
            <InputContainer>
                <InputContent>
                    <SearchInput
                        value={value}
                        placeholder={placeholder}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    <InputIcon src={SearchIcon} alt="search" />
                </InputContent>
            </InputContainer>
        </Container>
    );
};

export default DeviceFilters;
